import { Button } from '@equifinance/shared';
import styled from 'styled-components';

export const ToggleButton = styled(Button)`${({ theme }) => `
  font-size: ${theme.fontSize[1]};
  background: none;
  color: ${theme.colours.primary[1]};

  &:last-child {
    margin-left: ${theme.padding[2]};
  }

  &:hover {
    background: ${theme.colours.primary[8]};
  }
`}`;

type ToggleButtonsProps = {
  onExpandAll(): void;
  onCollapseAll(): void;
}

export function ToggleButtons({ onExpandAll, onCollapseAll }: ToggleButtonsProps) {
  return (
    <>
      <ToggleButton onClick={onExpandAll}>
        <i className="mi-expand" />
        Expand all
      </ToggleButton>
      <ToggleButton onClick={onCollapseAll}>
        <i className="mi-minimize" />
        Collapse all
      </ToggleButton>
    </>
  );
}
